export const mapTruthy =
  <T, U = T>(fn: (x: T, i: number) => U) =>
  (list: T[]): NonNullable<U>[] => {
    return list.reduce((accumulator, item, currentIndex) => {
      const mapped = fn(item, currentIndex);
      if (mapped) {
        accumulator.push(mapped as NonNullable<U>);
      }
      return accumulator;
    }, [] as NonNullable<U>[]);
  };
